import React from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import Checklist3 from "../../../../assets/images/checklist3.png"

const ChecklistPurchase = () => {
  return (
    <div className="row">
      <div className="col-sm-12 col-md-6">
        <h5>Exigências e documentação necessaria para a contratação desse plano.</h5>
        <img src={Checklist3} alt="foto"></img>
      </div>
      <div className="col-sm-12 col-md-6">
        <h3>Checklist para a contrar o plano:</h3>
        <div>
          <ListGroup>
            <ListGroup.Item>
              ✅ Contrato de adesão: Informar que o cliente titular do contrato deverá estar presente para assina-lo.
            </ListGroup.Item>
            <ListGroup.Item>
              ✅ Agendamento de instalação: Informe ao cliente que um dos nossos atendentes entrará
              em contato para agendar a visita do técnico responsável pela instalação.
            </ListGroup.Item>
            <ListGroup.Item>
              ✅ Confirmação prévia da presença: Destaque que o técnico responsável pela instalação
              entrará em contato momentos antes da visita previamente agendada para confirmar se há alguém presente no local
              e que este seja responsável pela assinatura do contrato, ou que chegará em tempo hábil para assina-lo.
            </ListGroup.Item>
            <ListGroup.Item>
              ✅ Informe também que a instalação só será concluida após a assinatura do contrato de adesão.
            </ListGroup.Item>
            <ListGroup.Item>
              ✅ Informar ao cliente que o pagamento pela instalação deve ser efetuado diretamente ao técnico
              responsável pela instalação, podendo ser realizado em dinheiro ou por meio de Pix para a Melo Telecomunicações.
            </ListGroup.Item>
            <ListGroup.Item>
              ✅ Perguntar se o cliente tem alguma mais alguma dúvida sobre a contratação do plano.
            </ListGroup.Item>
            <ListGroup.Item>
              ✅ Criar uma Ordem de Serviço (OS) para o departamento/técnico responsável. <br />
              <a href="https://atendimento.gigabytetelecom.com.br" target="blank">Abrir o Sistema OS</a>
            </ListGroup.Item>
          </ListGroup>
        </div>
      </div>
      <br />
      <hr />
      <br />
      <div className="row">
        <h1>Feedback</h1>
        <div className="col-sm-12 col-md-6">

          Olá, [Nome do Cliente], saudações!<br /><br />

          Aqui é [Seu nome] da Gigabyte Telecom! Esperamos que você esteja aproveitando nossa conexão de internet [nome do plano] e que esteja atendendo às suas expectativas.
          <br /><br />
          Estamos entrando em contato para saber se você teria um tempinho para responder algumas perguntas rápidas sobre sua experiência até o momento. Queremos garantir que você esteja satisfeito com nossos serviços e que tudo esteja funcionando perfeitamente para você.
          <br /><br />
          As perguntas serão bem simples e não levarão muito do seu tempo. Sua opinião é muito importante para nós e nos ajuda a melhorar nossos serviços para atender ainda melhor às suas necessidades.
          <br /><br />
          Se estiver disponível para nos dar esse feedback, ficaremos muito agradecidos. Caso prefira, podemos agendar uma ligação para um horário que seja mais conveniente para você.
          <br /><br />
          De qualquer forma, estamos aqui para ajudar e garantir que você tenha a melhor experiência com a Gigabyte Telecom.
          <br /><br />
          Agradecemos pela sua atenção e aguardamos seu retorno.
          
        </div>
        <div className="col-sm-12 col-md-6">
          <h3>Checklist pós venda:</h3>
          <div>
            <ListGroup>
              <ListGroup.Item>
              ❓ 1 - Em uma escala de 0 a 10, qual nota você daria para a pontualidade do técnico na chegada ao local de instalação? 
              </ListGroup.Item>
              <ListGroup.Item>
              ❓ 2 - Como você avalia a cortesia e educação do técnico durante o atendimento, em uma escala de 0 a 10?
              </ListGroup.Item>
              <ListGroup.Item>
              ❓ 3 - Em relação à clareza das explicações dadas pelo técnico sobre o funcionamento dos equipamentos instalados, qual nota você atribuiria, em uma escala de 0 a 10?
              </ListGroup.Item>
              <ListGroup.Item>
              ❓ 4 - Como você avalia a agilidade e eficiência do técnico na realização da instalação, em uma escala de 0 a 10?
              </ListGroup.Item>
              <ListGroup.Item>
              ❓ 5 - Em uma escala de 0 a 10, qual nota você daria para a habilidade do técnico em resolver eventuais problemas ou dúvidas durante a instalação?
              </ListGroup.Item>
              <ListGroup.Item>
              ❓ 6 - Considerando o cuidado do técnico com o ambiente durante a instalação, qual nota você daria, em uma escala de 0 a 10?
              </ListGroup.Item>
              <ListGroup.Item>
              ❓ 7 - Como você avalia a disponibilidade do técnico em responder suas perguntas e fornecer informações adicionais, em uma escala de 0 a 10? 
              </ListGroup.Item>
              <ListGroupItem>
              ❓ 8 - Em relação à limpeza e organização dos equipamentos deixada pelo técnico após a instalação, qual nota você atribuiria, em uma escala de 0 a 10?
              </ListGroupItem>
              <ListGroupItem>
              ❓ 9 - Em geral, qual nota você daria para o atendimento do técnico de instalação, em uma escala de 0 a 10?
              </ListGroupItem>
            </ListGroup>
            <br />
            Lembrando que sua opinião é muito importante para nós, e suas respostas nos ajudarão a aprimorar nossos serviços e garantir a melhor experiência para todos 
            os nossos clientes. Agradecemos sua colaboração!
          </div>
        </div>
      </div>
    </div>
  )
}
export default ChecklistPurchase;